import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PendingTask  {
    _originalTypeClassName = "zSHR.BO.PendingTask";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PendingTask.translate = translateService;
}
this.Notifications = [];
this.Id = null;
this.DateCreated = null;
this.IsFinished = false;
this.DateResolved = null;
this.Type = null;
this.ClassName = null;
this.ClassId = null;
this.PendingTaskKey = null;
this._key = this.PendingTaskKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
DateCreated:any;
IsFinished:any;
DateResolved:any;
Type:any;
ClassName:any;
ClassId:any;
Notifications:any;
private _PendingTaskKey:any;
get PendingTaskKey(): any {
    return this._PendingTaskKey;
  }
set PendingTaskKey(value: any) {
    this._PendingTaskKey = value;
    this._key = value;
  }
static setNotifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Notifications == null) $this.Notifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Notifications.length > 0) {
                    Domain.PendingTask.removeNotifications($this, $this.Notifications[0]);
                }

                Domain.PendingTask.addManyNotifications($this, copyItems);
            }
static addManyNotifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PendingTask.addNotifications($this, items[i]);
                }
            }
static addNotifications = ($this, item) => {
                if ($this.Notifications == null) $this.Notifications = [];
                if (item == null || $this.Notifications.indexOf(item) > -1) return;
                $this.Notifications.push(item);
if (item.PendingTask != $this) {
Domain.Notification.setPendingTask(item, $this);
}
}
static addRangeNotifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PendingTask.addNotifications($this, item));
            }
static removeNotifications = ($this, item) => {
                if ($this == null || $this.Notifications == null || $this.Notifications.indexOf(item) === -1) return;
                var _index = $this.Notifications.indexOf(item);
                $this.Notifications.splice(_index, 1);
item.PendingTask = null;
}
static clearNotifications = ($this) => { $this.Notifications = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PendingTaskKey == null || $this.PendingTaskKey == 0;
            }


}